module.exports = __webpack_public_path__ + "static/media/pdf.fd9a08fe.svg";